var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJewelry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#727831",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.57 9.59a.9.9 0 0 1 1.527 0l5.333 8.533a.9.9 0 0 1-.763 1.377H8a.9.9 0 0 1-.763-1.377L12.57 9.59zm.763 2.175L9.623 17.7h7.42l-3.71-5.935z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.237 9.59a.9.9 0 0 1 1.526 0l5.334 8.533a.9.9 0 0 1-.764 1.377H18.667a.9.9 0 0 1-.764-1.377l5.334-8.533zM24 11.765L20.29 17.7h7.42L24 11.765z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.537 18.372a.9.9 0 1 0-1.741.456l5.333 20.4c.235.896 1.507.896 1.742 0l5.333-20.4a.9.9 0 1 0-1.741-.456L24 35.442l-4.463-17.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.903 9.59a.9.9 0 0 1 1.527 0l5.333 8.533A.9.9 0 0 1 40 19.5H29.333a.9.9 0 0 1-.763-1.377l5.333-8.533zm-2.946 8.11h7.42l-3.71-5.935-3.71 5.935z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 10.967h21.334a.9.9 0 0 0 0-1.8H13.333a.9.9 0 0 0 0 1.8zM8.708 18.045a.9.9 0 0 0-1.416 1.11l16 20.4a.9.9 0 0 0 1.416 0l16-20.4a.9.9 0 1 0-1.416-1.11L24 37.542 8.708 18.045z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry);
export default __webpack_public_path__ + "static/media/jewelry.63c92739576d4c55341a0e72a72ed875.svg";
export { ForwardRef as ReactComponent };